var userTypes = [
  { name: 'SuperAdmin', label: 'مدیر سیستم', value: 0 },
  { name: 'SalesManager', label: 'مسئول برنامه‌ریزی تولید', value: 1 },
  { name: 'ProductionManager', label: 'مدیر تولید', value: 2 },
  {
    name: 'MaterialWarehouseManager',
    label: 'مدیر انبار مواد اولیه',
    value: 3
  },
  { name: 'ImpregnationUnitManager', label: 'مدیر واحد آغشته سازی', value: 4 },
  {
    name: 'ImpregnationUnitShiftManager',
    label: 'سرپرست شیفت آغشته سازی',
    value: 5
  },
  { name: 'PressUnitManager', label: 'مدیر پرس', value: 6 },
  { name: 'PressUnitShiftManager', label: 'سرپرست شیفت پرس', value: 7 },
  { name: 'CuttingUnitManager', label: 'مدیر برش', value: 8 },
  { name: 'CuttingUnitShiftManager', label: 'سرپرست شیفت برش', value: 9 },
  { name: 'ClickUnitManager', label: 'مدیر کلیک', value: 10 },
  { name: 'ClickUnitShiftManager', label: 'سرپرست شیفت کلیک', value: 11 },
  { name: 'WarehouseManager', label: 'مدیر انبار', value: 12 },
  {
    name: 'SemiFinishedWarehouseManager',
    label: 'مدیر انبار نیمه ساخته',
    value: 13
  },
  { name: 'system', label: 'سیستم', value: 14 }
]

export default userTypes
